// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zone {\n  background: var(--selectedColor);\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 30px;\n  height: 40px;\n  border-radius: 0 20px 20px 0;\n  box-shadow: 0 0 10px rgba(0,0,0,0.2);\n  z-index: -1;\n  transition: linear all 0.1s !important;\n}\n.nav .arbo .accordion-bloc.active .zone {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
